export const MAX_FILES = 100
export const CONCURRENCY = 5
export const ACCEPTED_EXT = '.pdf'
